export enum EIQVoiceVersion {
  V1_0 = 'V1_0',
  V1_1 = 'V1_1',
}

export const eiqVoiceVersionMap: Record<EIQVoiceVersion, string> = {
  [EIQVoiceVersion.V1_0]: 'v1.0 default',
  [EIQVoiceVersion.V1_1]: 'v1.1 Short version with dial options',
};

export const eiqVoiceVersionOptions = [
  { value: EIQVoiceVersion.V1_0, label: eiqVoiceVersionMap[EIQVoiceVersion.V1_0] },
  { value: EIQVoiceVersion.V1_1, label: eiqVoiceVersionMap[EIQVoiceVersion.V1_1] },
];
